// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b485d92f","977":"8d138abf"}[chunkId] + ".chunk.js";
};